import { Environment } from '../environments/environment'
import { LocaleId } from '../models'

type Link = string
type LinkLocalized = Record<LocaleId, Link>

interface LinkConfig {
  accessibilityStatement: Link
  privacyPolicy: Link
  rentYourOwnHolidayWeek: LinkLocalized
  serviceTerms: Link
  store: LinkLocalized
  storeServices: Link
  termsOfBookings: LinkLocalized
  termsOfDigitalServices: Link
  termsOfOwnership: Link
  termsOfRental: Link
  webshop: Link
  webshopSignUpComplete: Link
  welcomePresentation: Link
}

/* Query param provided to help syncing sessions */
const LOMA_REFERENCE_QUERY = '?ref=loma'
const DOMAIN = 'https://holidayclubresorts.com'

export const LINK_CONFIG: LinkConfig = {
  accessibilityStatement: `${DOMAIN}/fi/footermenu/verkkopalvelustamme/saavutettavuusseloste-omat-lomasivut/?_gl=1*1stsn4y*_gcl_au*MTMxNzE2NjcwNi4xNzc5ODg3OTc4*_ga*MjAwMTc3OTczMy4xNzc5ODg3MDQy*_ga_94Q1HJJTLG*czE3Nzk4ODcwNDEkbzEkZzEkdDE3Nzk4ODc5NzYkajYwJGwwJGgw`,
  privacyPolicy: `${DOMAIN}/fi/footermenu/verkkopalvelustamme/tietosuoja/?_gl=1*v17pvy*_ga*MjAwMTc3OTczMy4xNzc5ODg3MDQy*_ga_94Q1HJJTLG*czE3Nzk4ODcwNDEkbzEkZzEkdDE3Nzk4ODczMTIkajYwJGwwJGgw`,
  rentYourOwnHolidayWeek: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/en/ownership/viikko-osake/renting-out/`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/omistaminen/viikko-osake/vuokravalitys#lomakkeet`,
  },
  serviceTerms: `${DOMAIN}/fi/footermenu/verkkopalvelustamme/digitaalisten-palveluiden-kayttoehdot/?_gl=1*v17pvy*_ga*MjAwMTc3OTczMy4xNzc5ODg3MDQy*_ga_94Q1HJJTLG*czE3Nzk4ODcwNDEkbzEkZzEkdDE3Nzk4ODczMTIkajYwJGwwJGgw`,
  store: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/en/store`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/store/?`,
  },
  storeServices: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/store/lisapalvelut-uusi/lista`,
  termsOfBookings: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/en/booking-terms-and-conditions/terms-and-conditions/`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/varausehdot/yhdistetyt-ehdot/`,
  },
  termsOfDigitalServices: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/footermenu/verkkopalvelustamme/digitaalisten-palveluiden-kayttoehdot/`,
  termsOfOwnership: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/omistaminen/omistajien-digipalvelut/`,
  termsOfRental: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/omistaminen/viikko-osake/vuokravalitys/`,
  webshop: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}`,
  webshopSignUpComplete: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/sign-up-complete/`,
  welcomePresentation: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/omistaminen/tervetuloa-esittelyyn/`,
}
